export default __webpack_public_path__ + "static/media/G89A3279_tn.09ac1501.jpg";